import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";
import { IMAGES, useContent } from "@/data/content";
import { useSeo } from "@/hooks/useSeo";

export default function Privacy() {
  const { ui } = useContent();
  const p = ui.privacy;
  useSeo({ title: p.heroTitle, description: p.intro });
  return (
    <main className="bg-cream" data-testid="privacy-page">
      <PageHero eyebrow={p.heroEyebrow} title={p.heroTitle} image={IMAGES.botanical} testid="privacy-hero" />
      <section className="mx-auto max-w-3xl px-6 pb-28">
        <Reveal>
          <p className="text-base leading-relaxed text-soft drop-cap" data-testid="privacy-intro">{p.intro}</p>
          <div className="mt-14 space-y-12">
            {p.sections.map((s, i) => (
              <div key={i} data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-2xl tracking-tight text-ink">{s.title}</h2>
                {s.paras.map((para, j) => (
                  <p key={j} className="mt-4 text-base leading-relaxed text-soft">{para}</p>
                ))}
              </div>
            ))}
          </div>
          <p className="mt-14 text-xs tracking-wide text-soft/60">{p.updated}</p>
        </Reveal>
      </section>
    </main>
  );
}
